module.exports = __webpack_public_path__ + "img/ui_ux.de35351e.png";